import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';

const breakpoints = {
    sm: 1200,
    xsm: 768
    // md: 1200,
    // lg: 1400
};

let cachedDimensions = null;
const getDimensions = () => {
    if (!cachedDimensions) {
        if (typeof window.innerWidth !== 'undefined') {
            cachedDimensions = { H: window.innerHeight, W: window.innerWidth };
        } else {
            cachedDimensions = {
                H: document.documentElement.offsetHeight,
                W: document.documentElement.offsetWidth
            };
        }
    }
    return cachedDimensions;
};
if (typeof window === 'object') {
    window.addEventListener('resize', () => {
        cachedDimensions = null;
    });
} else {
    cachedDimensions = { W: 1920, H: 640 };
}

const media = f => f(getDimensions(), breakpoints);

const isMobile = ({ W }, { xsm, sm }, { deviceMobile = false }) => ({
    isMobile: W <= sm || deviceMobile,
    isPhone: W <= xsm
})

export const useMobile = (...props) => {
    const screenToPropsMapper = (s, br) => isMobile(s, br, props);
    const oldIsMobile = useRef(media(screenToPropsMapper).isMobile);
    const oldIsPhone = useRef(media(screenToPropsMapper).isPhone)

    const [ mediaProps, setMediaProps ] = useState(media(screenToPropsMapper));

    const handleResize = useCallback(() => {
        const isMobile = media(screenToPropsMapper).isMobile;
        const isPhone = media(screenToPropsMapper).isPhone;
        if (oldIsMobile.current !== isMobile) {
            oldIsMobile.current = isMobile;
            setMediaProps(oldMediaProps => ({isMobile, isPhone: oldMediaProps.isPhone}));
        }
        if (oldIsPhone.current !== isPhone) {
            oldIsPhone.current = isPhone;
            setMediaProps(oldMediaProps => ({isPhone, isMobile: oldMediaProps.isMobile}));
        }
    }, [media(screenToPropsMapper).isPhone, media(screenToPropsMapper).isMobile]);

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        window.addEventListener('orientationchange', handleResize);
        window.addEventListener('orientationchangeend', handleResize);
        handleResize();
        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('orientationchange', handleResize);
            window.removeEventListener('orientationchangeend', handleResize);
        }
    }, [])

    return mediaProps;
};
